import { Injectable } from '@angular/core';
import { WizardStepResolve } from '../../../../shared/wizard/wizard-step-resolve.service';
import { AuthorizationStepsService } from './authorization-steps.service';

@Injectable()
export class AuthorizationStepsResolve extends WizardStepResolve {
	constructor(wizardService: AuthorizationStepsService) {
		super(wizardService);
	}
}